import "vuetify/styles";
import {createVuetify} from "vuetify";

const them = {
    dark: false,
    colors: {
        background: "#e9f1fe",
        surface: "#FFFFFF",
        primary: "#2196F3",
        creditCardBorderColor: "#3b5998",
        'page-background-color': "#F7F9FC",
        'table-primary-color': "#C47F20",
        'table-secondary-color': "#C37C1B",
        'table-row-active-color': "#F7F9FCB4",
        'table-accent-color': "#000000",
        'delete-btn-color': "#CE1214",
        'chip-red-color': "#A12027",
        'chip-green-color': "#00674B",
        'radio-color': '#EBB824',
        'info-color': '#FEF8E3',
        'scan-filter-text': '#F9F9F9',
        'curated-service-grey-1': '#E0E3EA',
        'curated-service-text-1': '#9195A8',
        'curated-service-text-2': '#C37C1B',
        'curated-alert-color': '#FEF8E3',
        'curated-checkbox-color': '#F7CC4F',
        'curated-text-grey': '#393939',
    }
}

export default createVuetify({
    options: {
        customProperties: true,
    },
    theme: {
        defaultTheme: 'them',
        themes: {them}
    },
})